/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilityprivate1Inputs */

const zh_share_visibilityprivate1 = /** @type {(inputs: Share_Visibilityprivate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私密`)
};

const en_share_visibilityprivate1 = /** @type {(inputs: Share_Visibilityprivate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

const es_share_visibilityprivate1 = /** @type {(inputs: Share_Visibilityprivate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privado`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {Share_Visibilityprivate1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilityprivate1 = /** @type {((inputs?: Share_Visibilityprivate1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilityprivate1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilityprivate1(inputs)
	if (locale === "en") return en_share_visibilityprivate1(inputs)
	return es_share_visibilityprivate1(inputs)
});
export { share_visibilityprivate1 as "share_visibilityPrivate" }